module.exports = __webpack_public_path__ + "img/az-logo copy.dd2abe66.png";